module.exports = __webpack_public_path__ + "app/images/icons/seite.svg";